import type { IframeAttributes } from '@unifyapps/defs/blocks/Iframe/types';

const SANDBOX_PERMISSION_ATTRIBUTES = {
  downloads: 'allow-downloads',
  forms: 'allow-forms',
  popups: 'allow-popups',
  modals: 'allow-modals',
  topNavigation: 'allow-top-navigation',
  topNavigationByUserActivation: 'allow-top-navigation-by-user-activation',
  topNavigationToCustomProtocols: 'allow-top-navigation-to-custom-protocols',
  storageAndCookies: 'allow-same-origin',
} as const;

const PERMISSIONS_POLICY_DIRECTIVES = {
  camera: 'camera;',
  microphone: 'microphone;',
  geolocation: 'geolocation;',
  fullscreen: 'fullscreen;',
} as const;

const BASE_SANDBOX_PERMISSIONS = ['allow-scripts'];

type SandboxPermissionKey = keyof typeof SANDBOX_PERMISSION_ATTRIBUTES;
type PolicyDirectiveKey = keyof typeof PERMISSIONS_POLICY_DIRECTIVES;

export function getSandboxAttributes(attributes?: IframeAttributes): string {
  if (!attributes) return BASE_SANDBOX_PERMISSIONS.join(' ');

  const extraPermissions = Object.entries(attributes)
    .filter(([key, isEnabled]) => isEnabled && key in SANDBOX_PERMISSION_ATTRIBUTES)
    .map(([key]) => SANDBOX_PERMISSION_ATTRIBUTES[key as SandboxPermissionKey]);

  return [...BASE_SANDBOX_PERMISSIONS, ...extraPermissions].join(' ');
}

export function getPermissionsPolicy(attributes?: IframeAttributes): string {
  if (!attributes) return '';

  const policies = Object.entries(attributes)
    .filter(([key, isEnabled]) => isEnabled && key in PERMISSIONS_POLICY_DIRECTIVES)
    .map(([key]) => PERMISSIONS_POLICY_DIRECTIVES[key as PolicyDirectiveKey]);

  return policies.length ? policies.join(' ') : '';
}
